import React, { FC } from 'react';
import { HeaderButton } from '@ingka-group-digital/cwds-react-header';
import questionMarkCircleIcon from '@ingka/ssr-icon/paths/question-mark-circle';

const AppbarUtilities: FC = () => {
  return (
    <>
      <HeaderButton
        ssrIcon={questionMarkCircleIcon}
        onClick={() =>
          window.open(
            'https://iweof.sharepoint.com/sites/ret/newbusinessexpansion/SitePages/EXPANSION-PROJECT-PORTFOLIO-TOOLS.aspx?ga=1',
          )
        }
      />
    </>
  );
};

export default AppbarUtilities;
